import React from "react";
import { Button, Toast } from "antd-mobile";
import { href } from "../../utils/util";

import dianzihetongPNG from "./image/dianzihetong.png";

import "./index.less";

class ACEntrance extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            mobileNumber: "",
        };
    }

    componentDidMount() {
        var obj = "",
            obj1 = "",
            ops = {};
        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] = obj1[i].split("=")[1];
            }
            this.setState({
                mobileNumber: ops.mobileNumber,
            });
            if (ops["thirdContractId"]) {
                localStorage.setItem("thirdContractId", ops["thirdContractId"]);
            } else {
                Toast.info("没有获取到第三方合同ID", 30);
            }
        } else {
            Toast.info("链接错误", 30);
        }
    }

    viewPort() {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf("micromessenger") > -1,
            isQQ: u.indexOf("qq/") > -1,
            trident: u.indexOf("trident") > -1, //IE内核
            presto: u.indexOf("presto") > -1, //opera内核
            webKit: u.indexOf("applewebkit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("gecko") > -1 && u.indexOf("khtml") == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) || !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf("android") > -1 || u.indexOf("linux") > -1, //android终端或者uc浏览器
            iPhone: u.indexOf("iphone") > -1 || u.indexOf("mac") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("ipad") > -1, //是否iPad
            webApp: u.indexOf("safari") == -1, //是否web应该程序，没有头部与底部
        };
    }

    render() {
        return (
            <div className="ACEntranceBox">
                <h3>线上签合同，成单合作更轻松</h3>
                <img src={dianzihetongPNG} />
                <div className="btnBOx">
                    <Button
                        type="primary"
                        onClick={() => {
                            let viewPort = this.viewPort();
                            if (
                                viewPort.ios ||
                                viewPort.iPhone ||
                                viewPort.iPad
                            ) {
                                window.open(
                                    "https://itunes.apple.com/cn/app/id1409533598?mt=8"
                                );
                            } else {
                                window.open("tf56.com://huilian");
                            }
                        }}
                    >
                        远程慧联APP
                    </Button>
                    <Button
                        onClick={() => {
                            href(
                                `/ACLogin?mobileNumber=${this.state.mobileNumber}`
                            );
                        }}
                    >
                        网页端
                    </Button>
                    <a
                        className="xiazai"
                        onClick={() => {
                            // href('/HuilianDownload');
                            window.location.href =
                                window.location.origin +
                                "/appDownload/#/HuilianDownload";
                        }}
                    >
                        下载远程慧联APP
                    </a>
                </div>
            </div>
        );
    }
}

export default ACEntrance;



// WEBPACK FOOTER //
// ./src/authCertificate/ACEntrance/index.js